import React from 'react';

import SkinAnalysisReport from '../components/common/SkinAnalysisReport';
import { useParams, useLocation } from 'react-router-dom';

const SkinDetailReport = () => {
  let { id } = useParams();
  const { state } = useLocation();

  return <SkinAnalysisReport report={state} />;
};

export default SkinDetailReport;
